import {
  IMilestoneApprover,
  INotificationRole,
  IProjectRole,
} from "@/interfaces";

export const clearRoleDependancies = <
  T extends IMilestoneApprover | INotificationRole
>(
  roles: IProjectRole[],
  item: T,
  row: T
): T => {
  const updatedRow = { ...row };
  if (!roles) return updatedRow;

  if (item.roleId !== updatedRow.roleId && updatedRow.region !== undefined) {
    updatedRow.region = "";
  }

  if (
    updatedRow.region !== undefined &&
    item.region !== updatedRow.region &&
    updatedRow.functionalArea !== undefined
  ) {
    updatedRow.functionalArea = "";
  }

  if (row.roleId) {
    const role = roles.find(({ id }: { id: string }) => id === row.roleId);
    if (
      item.roleId !== updatedRow.roleId ||
      !role?.regionalProjectRoles?.some(
        ({ region }: { region: string }) => region === row.region
      )
    ) {
      updatedRow.region = "";
    }

    if (
      item.region !== updatedRow.region ||
      !role?.regionalProjectRoles?.some(
        ({ functionalArea }: { functionalArea: string }) =>
          functionalArea === row.functionalArea
      )
    ) {
      updatedRow.functionalArea = "";
    }
  }

  return updatedRow;
};
